export default __webpack_public_path__ + "static/media/bg-desktop.2f95a231.jpg";